const store = {
    /**
     * Add or update an item in storage.
     *
     * @param {String} key   - The name of the entry.
     * @param {Mixed}  value - The value of the entry.
     * @param {Mixed}  [ttl] - The expiration date/time of the entry.
     */
    set: function (key, value, ttl) {
        let data = { value: value, expires_at: this.parseTime(ttl) };
        sessionStorage.setItem(key.toString(), JSON.stringify(data));
    },
    /**
     * Retrieve the entry in storage.
     *
     * @param  {String} key - The name of the entry.
     * @return {Mixed}
     */
    get: function (key) {
        let data = JSON.parse(sessionStorage.getItem(key.toString()));
        if (data !== null) {
            if (data.expires_at !== null && data.expires_at < new Date().getTime()) {
                sessionStorage.removeItem(key.toString());
            } else {
                return data.value;
            }
        }
        return null;
    },
    /**
     * Parse the given time.
     *
     * @param  {Date|Integer|String} time - A date/time value.
     *     Can be one of:
     *     1. an integer representing the number of milliseconds since the Unix Epoch,
     *     2. a string representing a date/time, or
     *     3. an instance of the Date object.
     * @return {Integer|Null}
     */
    parseTime: function (time) {
        if (time instanceof Date) {
            return time.getTime();
        } else if (typeof time === 'string') {
            return new Date(time).getTime();
        } else if (typeof time === 'number') {
            return (new Date().getTime() + time / 1);
        } else {
            return null;
        }
    }
};

export { store };
